/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { FileTree } from './FileTree';
const RootFileTreesJSONParser = /* #__PURE__ */ parsers.object([
    ['teacher', /* #__PURE__ */ parsers.maybeNull(FileTree)],
    ['student', FileTree],
]);
export class RootFileTreesJSON extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return RootFileTreesJSONParser.decode(input).map(res => new RootFileTreesJSON(res));
    }
    static unsafeDecode(input) {
        return RootFileTreesJSON.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return RootFileTreesJSONParser.encode(data);
    }
    static schema() {
        return RootFileTreesJSONParser.schema();
    }
}
